function refreshCart() {
  fetch(`${routes.cart_url}?section_id=cart-drawer`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
      for (const selector of selectors) {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.replaceWith(sourceElement);
        }
      }
    })
    .catch((e) => {
      console.error(e);
    });
}

Shopify.Cart = Shopify.Cart || {};
Shopify.Cart.GiftWrapTag = {};

function updateCartItemQuantityByVariantId(variantId, quantity) {
  return fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const lineItem = cart.items.find(item => item.variant_id === Number(variantId));
      if (!lineItem) {
        throw new Error('Variant not found in cart');
      }

      const lineItemKey = lineItem.key;

      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineItemKey, quantity })
      });
    })
    .then(response => {
      if (!response.ok) throw new Error('Cart update failed');
      return response.json();
    })
    .catch((e) => {
      console.error('Error updating cart item quantity:', e);
    });
}

Shopify.Cart.GiftWrapTag.addGiftProductWithQuantity = function(TagGwpVariantId, quantity = 1) {
  var headers = new Headers({ 'Content-Type': 'application/json' });
  return fetch('/cart/update.js', {
    method: 'POST',
    headers,
    body: JSON.stringify({ attributes: { free_product_variant_id: TagGwpVariantId } })
  })
  .then(() => {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers,
      body: JSON.stringify({ id: TagGwpVariantId, quantity: quantity })
    });
  })
  .then(response => response.json())
  .catch((e) => {
    console.error('Error adding gift product with quantity:', e);
    throw e;
  });
};

Shopify.Cart.GiftWrapTag.removeGiftProduct = function(TagGwpVariantId) {
  var headers = new Headers({ 'Content-Type': 'application/json' });

  return fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const item = cart.items.find(i => i.variant_id === Number(TagGwpVariantId));
      if (!item) {
        throw new Error('Gift product not found in cart');
      }

      const lineItemKey = item.key;

      return fetch('/cart/change.js', {
        method: 'POST',
        headers,
        body: JSON.stringify({ id: lineItemKey, quantity: 0 })
      });
    })
    .then(() => {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers,
        body: JSON.stringify({ attributes: { free_product_variant_id: '' } })
      });
    })
    .then(response => response.json())
    .catch((e) => {
      console.error('Error removing gift product:', e);
      throw e;
    });
};

function checkTagCond() {
  
  const gwpInputs = document.querySelectorAll('.single_gwp_input');
  if (!gwpInputs.length) return;

  jQuery.getJSON('/cart.js', function(cart) {
    const updatePromises = [];

    gwpInputs.forEach(gwpInput => {
      const mainProductId = parseInt(gwpInput.getAttribute('data-main-product-id'));
      const freeVariantId = parseInt(gwpInput.getAttribute('data-gwp-variant-id'));

      const mainProductItem = cart.items.find(item => item.product_id === mainProductId);
      const freeProductItem = cart.items.find(item => item.id === freeVariantId);

      const mainProductQuantity = mainProductItem ? mainProductItem.quantity : 0;
      const freeProductQuantity = freeProductItem ? freeProductItem.quantity : 0;

  if (mainProductItem) {

  if (!freeProductItem) {
    updatePromises.push(
      Shopify.Cart.GiftWrapTag.addGiftProductWithQuantity(freeVariantId, 2)
    );
    console.log(`Added free product ${freeVariantId} with qty 2`);
  } 
  else if (freeProductItem.quantity !== 2) {
    updatePromises.push(
      updateCartItemQuantityByVariantId(freeVariantId, 2)
    );
    console.log(`Updated free product ${freeVariantId} to qty 2`);
  }

} else if (!mainProductItem && freeProductItem) {

  updatePromises.push(
    Shopify.Cart.GiftWrapTag.removeGiftProduct(freeVariantId)
  );
  console.log(`Removed free product ${freeVariantId}`);
}

    });

    if (updatePromises.length > 0) {
      Promise.all(updatePromises).then(() => {
        console.log('All cart updates completed. Refreshing UI...');
        refreshCart();
      }).catch((e) => {
        console.error('Error during cart updates:', e);
      });
    }
  });
}

document.addEventListener('click', function (e) {
  const button = e.target.closest('.add-to-cart');
  if (!button) return;

  e.preventDefault();

  if (button.classList.contains('is-loading')) return;
  button.classList.add('is-loading');

  const variantId = button.getAttribute('data-var_id');
  const quantity = parseInt(button.getAttribute('data-quantity'), 10) || 1;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: variantId,
      quantity: quantity
    })
  })
  .then(res => res.json())
  .then(() => {
    refreshCart();
  })
  .catch(err => {
    console.error(err);
  })
  .finally(() => {
    button.classList.remove('is-loading');
  });
});



document.addEventListener("click", function (event) {
  const isQtyBtn = event.target.closest("#CartDrawer .cart-item .quantity__button");
  const isRemoveBtn = event.target.closest("#CartDrawer .cart-item .cart-remove-button");
  
  if (isQtyBtn || isRemoveBtn) {
    setTimeout(() => {
      checkTagCond();
    }, 1000);
  }

});


document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('form[action^="/cart/add"]').forEach(function(form) {
    form.addEventListener('submit', function () {
      setTimeout(() => {
        checkTagCond();
      }, 1500);
    });
  });
});

checkTagCond();